import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const NotePadIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5.12109 1H10.8789C11.2743 0.999987 11.6153 0.999976 11.8963 1.02293C12.1928 1.04715 12.4877 1.10064 12.7715 1.24524C13.1948 1.46095 13.5391 1.80516 13.7548 2.22852C13.8994 2.51231 13.9528 2.80722 13.9771 3.10373C14 3.38466 14 3.72572 14 4.12108V5.00027C13.4686 4.99165 12.9346 5.19007 12.5291 5.59553L12.5 5.62463V4.15C12.5 3.71759 12.4994 3.43838 12.4821 3.22588C12.4654 3.02213 12.4372 2.94659 12.4183 2.90951C12.3464 2.76839 12.2316 2.65365 12.0905 2.58175C12.0534 2.56285 11.9779 2.53459 11.7741 2.51795C11.5616 2.50058 11.2824 2.5 10.85 2.5H5.15C4.71759 2.5 4.43838 2.50058 4.22588 2.51795C4.02213 2.53459 3.94659 2.56285 3.90951 2.58175C3.76839 2.65365 3.65365 2.76839 3.58175 2.90951C3.56285 2.94659 3.53459 3.02213 3.51795 3.22588C3.50058 3.43838 3.5 3.71759 3.5 4.15V11.85C3.5 12.2824 3.50058 12.5616 3.51795 12.7741C3.53459 12.9779 3.56285 13.0534 3.58175 13.0905C3.65365 13.2316 3.76839 13.3464 3.90951 13.4183C3.94659 13.4372 4.02213 13.4654 4.22588 13.4821C4.43838 13.4994 4.71759 13.5 5.15 13.5H5.26017C5.11678 13.9039 5.02909 14.3288 5.00227 14.7633C4.99728 14.8441 5.00061 14.9232 5.01146 15C4.66238 14.9998 4.35835 14.9979 4.10373 14.9771C3.80722 14.9528 3.51231 14.8994 3.22852 14.7548C2.80516 14.5391 2.46095 14.1948 2.24524 13.7715C2.10064 13.4877 2.04715 13.1928 2.02293 12.8963C1.99998 12.6153 1.99999 12.2743 2 11.8789V4.12109C1.99999 3.72573 1.99998 3.38466 2.02293 3.10373C2.04715 2.80722 2.10064 2.51231 2.24524 2.22852C2.46095 1.80516 2.80516 1.46095 3.22852 1.24524C3.51231 1.10064 3.80722 1.04715 4.10373 1.02293C4.38466 0.999976 4.72573 0.999987 5.12109 1Z"
		></path>
		<path
			fill="currentColor"
			d="M8.8336 15H10.8789C11.2743 15 11.6153 15 11.8963 14.9771C12.1928 14.9528 12.4877 14.8994 12.7715 14.7548C13.1948 14.5391 13.5391 14.1948 13.7548 13.7715C13.8994 13.4877 13.9528 13.1928 13.9771 12.8963C14 12.6153 14 12.2743 14 11.8789V9.87548L12.5 11.3755V11.85C12.5 12.2824 12.4994 12.5616 12.4821 12.7741C12.4654 12.9779 12.4372 13.0534 12.4183 13.0905C12.3464 13.2316 12.2316 13.3464 12.0905 13.4183C12.0534 13.4372 11.9779 13.4654 11.7741 13.4821C11.5616 13.4994 11.2824 13.5 10.85 13.5H10.3755L9.22461 14.6509C9.10042 14.7751 8.96983 14.8916 8.8336 15Z"
		></path>
		<path
			fill="currentColor"
			d="M12.5 9.96128L14 8.46126V6.00053C13.7246 5.99174 13.4464 6.09244 13.2362 6.30263L12.5 7.03886V9.96128Z"
		></path>
		<path
			fill="currentColor"
			d="M10.9778 7.14686L9.62468 8.5H5.25C5.11193 8.5 5 8.38807 5 8.25V7.25C5 7.11193 5.11193 7 5.25 7H10.75C10.8513 7 10.9385 7.06024 10.9778 7.14686Z"
		></path>
		<path
			fill="currentColor"
			d="M8.1247 10L6.62472 11.5H5.25C5.11193 11.5 5 11.3881 5 11.25V10.25C5 10.1119 5.11193 10 5.25 10H8.1247Z"
		></path>
		<path
			fill="currentColor"
			d="M8.03892 11.5L9.5389 10H10.75C10.8881 10 11 10.1119 11 10.25V11.25C11 11.3881 10.8881 11.5 10.75 11.5H8.03892Z"
		></path>
		<path
			fill="currentColor"
			d="M6.34047 13.5H8.96133L8.5175 13.9438C8.09147 14.3699 7.56943 14.6799 7.00085 14.8516C6.96777 14.8616 6.93357 14.8714 6.90017 14.8805C6.66469 14.9442 6.42187 14.9845 6.17512 14.9997C6.07618 15.0058 5.99426 14.9238 6.00037 14.8249C6.0156 14.5782 6.05588 14.3353 6.11966 14.0998C6.1287 14.0665 6.13822 14.0332 6.1482 14.0001C6.19988 13.8291 6.26436 13.6613 6.34047 13.5Z"
		></path>
		<path
			fill="currentColor"
			d="M5 4.25C5 4.11193 5.11193 4 5.25 4H10.75C10.8881 4 11 4.11193 11 4.25V5.25C11 5.38807 10.8881 5.5 10.75 5.5H5.25C5.11193 5.5 5 5.38807 5 5.25V4.25Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.6974 6.30263C15.1009 6.70613 15.1009 7.36032 14.6974 7.76382L8.5175 13.9438C7.89163 14.5697 7.05856 14.9452 6.17512 14.9997C6.07618 15.0058 5.99426 14.9238 6.00037 14.8249C6.0549 13.9415 6.43036 13.1085 7.05618 12.4827L13.2362 6.30263C13.6397 5.89912 14.2939 5.89912 14.6974 6.30263Z"
		></path>
	</svg>
))
